import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-white px-4 py-5" data-id="element-71" data-mp="1o3x3nprb6w3l">
      <div className="mx-auto flex max-w-3xl items-start gap-3 rounded-xl border-2 border-brand-carbon bg-brand-paper p-3 sm:p-4" data-id="element-72" data-mp="1o33uyj8shwit">
        <ShieldCheckIcon aria-hidden="true" className="mt-0.5 h-8 w-8 shrink-0 text-brand-carbon" strokeWidth={2} data-id="element-73" data-mp="22125tenwjatk" />
        <div data-id="element-74" data-mp="19ehh6lyt9ctp">
          <h2 className="mb-1 font-display text-[17px] leading-tight sm:text-2xl" data-id="element-75" data-mp="19e7pmty4axlw">
            Your purchase is 100% protected
          </h2>
          <p className="text-[13px] font-medium leading-snug text-brand-muted sm:text-base" data-id="element-76" data-mp="14hhac8u5061j">
            Explore DIESEL DIAGNOSTIC PRO™ for 7 days. Access the complete 6-module diesel
            diagnostic system and all 5 professional bonuses. If it isn&apos;t right for you,
            contact us within 7 days for a full refund according to the refund terms.
          </p>
        </div>
      </div>
    </section>;
}